// DiscountsStep — DLOM model + minority discount (F4.1, F4.2, F4.4). Step 6.

import { useActiveValuation, useStore } from '../../store/selectors';
import { DlomModelSelector } from './DlomModelSelector';

export function DiscountsStep() {
  const active = useActiveValuation();
  const setDiscounts = useStore((s) => s.setDiscounts);
  if (!active) return null;
  const d = active.inputs.discounts;
  return (
    <div className="card">
      <div className="card-title">Discounts</div>
      <DlomModelSelector
        discounts={d}
        assumptions={active.inputs.assumptions}
        onChange={(patch) => setDiscounts(active.valuationId, patch)}
      />
    </div>
  );
}
